// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, enumOf, maybe, objectOf } from "@altostra/type-validations";
import { boolean, number, string } from "@altostra/type-validations/lib/primitives";

const isSuppressionRuleDeveloper = objectOf({
  developer_id: string,
  developer_name: maybe(string, true),
});

export const isSuppressionRuleResultItem = objectOf({
  id: string,
  type: maybe(enumOf("soft_bounce_to_hard_bounce"), true),
  app_group_id: string,
  name: string,
  status: enumOf("active", "inactive", "archived"),
  enabled: boolean,
  is_archived: boolean,
  created_at: maybe(number, true),
  last_edited: maybe(number, true),
  created_by: maybe(isSuppressionRuleDeveloper, true),
  last_edited_by: maybe(isSuppressionRuleDeveloper, true),
  // Present on `soft_bounce_to_hard_bounce` rules only.
  sending_domain: maybe(arrayOf(string), true),
  bounce_classifications: maybe(arrayOf(string), true),
  soft_bounce_count: maybe(number, true),
  min_days_apart: maybe(number, true),
  ui_state: maybe(
    objectOf({
      sender_profile: maybe(string, true),
      suppression_preset: maybe(string, true),
    }),
    true
  ),
});

export const isGetEngagementAppGroupIdSuppressionRulesResult = objectOf({
  hits: number,
  results: arrayOf(isSuppressionRuleResultItem),
});
